import React, { Fragment } from "react";
import PageTitle from "../../components/utility";
import { LayoutFluid } from "../../layouts";
import { BreadCrumbOne } from "../../components/BreadCrumb";
import { BlogStandard } from "../../components/Blogs";

const BlogStandardtPage = () => {
  return (
    <Fragment>
      <PageTitle
        PageTitle="Blog Post Standard - Appal - Mobile App Leanding Page"
        favicon="assets/images/logo/favourite-icon-0.png"
      />
      <LayoutFluid
        wrapperClass="blog-page"
        activeClass="active"
        sectionSpace="sec-ptb-160 pb-0"
        whitekContent="white-content"
        logoWhite="assets/images/logo/logo-1.png"
      >
        <main>
          <BreadCrumbOne
            title="Blog Post Standard"
            pageName="blog post"
            curentPageName="blog post"
          />
          <BlogStandard sectionSpace="sec-ptb-160 pb-0" />
        </main>
      </LayoutFluid>
    </Fragment>
  );
};

export default BlogStandardtPage;
